import { render, staticRenderFns } from "./goods-action.vue?vue&type=template&id=00ec7f1c&scoped=true"
import script from "./goods-action.vue?vue&type=script&lang=js"
export * from "./goods-action.vue?vue&type=script&lang=js"
import style0 from "./goods-action.vue?vue&type=style&index=0&id=00ec7f1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ec7f1c",
  null
  
)

export default component.exports